export const NEAREST_OFFERS_CONTAINER_TEST_ID =
  'explore-nearest-offers-container';

export const NEAREST_DEPARTURES_NO_FLIGHTS_TEXT =
  'explore-nearest-departures-no-flights-text';
export const NEAREST_DEPARTURES_OFFERS_INFO =
  'explore-nearest-departures-offers-info';

export const NEAREST_DATES_NO_FLIGHTS_TEXT =
  'explore-nearest-dates-no-flights-text';
export const NEAREST_DATES_OFFERS_INFO = 'explore-nearest-dates-offers-info';
